import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useNotification } from '../../../../helpers/Notification';
import FechasPersonalizada from '../../../../widgets/FechasPersonalizada';
import SelectFieldSeccionesComponent from '../../../control_estudios/secciones/components/SelectFieldSecciones';
import { allRecibosAction } from '../RecibosAction';
import { PARAMS_RECIBOS } from '../RecibosReducer';

let intervalSearch = null;

const FiltrosRecibosComponent = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const recibosStore = Redux.useSelector((state) => state.recibos);

  const getData = async (object) => {
    const payload = {
      ...recibosStore.params,
      ...object,
    };
    dispatch({
      type: PARAMS_RECIBOS,
      payload,
    });
    await allRecibosAction(dispatch, payload);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <Typography variant="h6" color="initial">
          FILTROS
        </Typography>
      </Grid>

      <FechasPersonalizada
        mdStart={12}
        mdEnd={12}
        startDate={recibosStore.params.desde}
        endDate={recibosStore.params.hasta}
        onStart={(desde) => {
          if (!desde) return;
          clearTimeout(intervalSearch);
          intervalSearch = setTimeout(async () => {
            getData({ desde });
          }, 800);
        }}
        onEnd={(hasta) => {
          if (!hasta) return;
          clearTimeout(intervalSearch);
          intervalSearch = setTimeout(async () => {
            getData({ hasta });
          }, 800);
        }}
      />

      <Grid item md={12}>
        <SelectFieldSeccionesComponent
          value={recibosStore.params.idSeccion}
          isEmpty={false}
          onChange={(idSeccion) => {
            getData({
              idSeccion,
            });
          }}
        />
      </Grid>
    </Grid>
  );
};

export default FiltrosRecibosComponent;
